import {HoistModel, managed} from '@xh/hoist/core';
import {DashContainerModel} from '@xh/hoist/desktop/cmp/dash';
import {Icon} from '@xh/hoist/icon';
import {positionsWidget} from './widgets/positions/PositionsWidget';
import {accountsWidget} from './widgets/accounts/AccountsWidget';
import {historicPerformanceWidget} from './widgets/historicPerformance/HistoricPerformanceWidget';
import {performanceWidget} from './widgets/performance/PerformanceWidget';
import {sectorMapWidget} from './widgets/sectorMap/SectorMapWidget';
import {allocationWidget} from './widgets/allocation/AllocationWidget';
import {moversWidget} from './widgets/movers/MoversWidget';
import {yoyWidget} from './widgets/yoyReturns/YoyWidget';
import {lineColumnsIcon} from '../../../core/Icons';

export class PerformanceTabModel extends HoistModel {
    @managed dashContainerModel: DashContainerModel = this.createDashModel();

    private createDashModel(): DashContainerModel {
        return new DashContainerModel({
            persistWith: {prefKey: 'performanceTabState'},
            showMenuButton: true,
            renameLocked: false,
            viewSpecs: [
                {
                    id: 'positions',
                    title: 'Positions',
                    icon: Icon.list(),
                    unique: false,
                    allowRemove: true,
                    allowAdd: true,
                    content: positionsWidget
                },
                {
                    id: 'accounts',
                    title: 'Accounts',
                    icon: Icon.treeList(),
                    unique: true,
                    allowRemove: true,
                    allowAdd: true,
                    content: accountsWidget
                },
                {
                    id: 'histPerformance',
                    title: 'Historical Performance',
                    icon: Icon.chartLine(),
                    unique: true,
                    allowRemove: true,
                    allowAdd: true,
                    content: historicPerformanceWidget
                },
                {
                    id: 'yoyReturns',
                    title: 'Yearly Returns',
                    icon: Icon.chartBar(),
                    unique: true,
                    allowRemove: true,
                    allowAdd: true,
                    content: yoyWidget
                },
                {
                    id: 'performance',
                    title: 'Performance',
                    icon: Icon.dollarSign(),
                    unique: true,
                    allowRemove: true,
                    allowAdd: true,
                    content: performanceWidget
                },
                {
                    id: 'sectorMap',
                    title: 'Sector Map',
                    icon: Icon.treeMap({prefix: 'fal'}),
                    unique: true,
                    allowAdd: true,
                    allowRemove: true,
                    content: sectorMapWidget
                },
                {
                    id: 'allocationMap',
                    title: 'Allocation Map',
                    icon: Icon.chartPie(),
                    unique: true,
                    allowAdd: true,
                    allowRemove: true,
                    content: allocationWidget
                },
                {
                    id: 'movers',
                    title: 'Movers',
                    icon: lineColumnsIcon(),
                    unique: true,
                    allowAdd: true,
                    allowRemove: true,
                    content: moversWidget
                }
            ],
            initialState: [
                {
                    type: 'row',
                    width: 100,
                    content: [{type: 'view', id: 'positions'}]
                }
            ]
        });
    }
}
